import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import { selectCompany } from "../../homeSlice";
import { useNavigate, useParams } from "react-router-dom";
import { useCallback, useEffect } from "react";
import {
  driversHistoryAsync,
  selectDriversHistoryListStatus,
} from "../fleetSlice";
import { AdvancedAnalyticsVehicles } from "../fleetApi";
import { AdvancedAnalyticsVehicleSidePanel } from "./AdvancedAnalyticsVehiclesSidePanel";
import "../../../../i18n/i18n";
import { SharedInterfaceAnalyticsVehiclesTab } from "./sharedInterface";

export const AnalyticsVehiclesTab = () => {
  const params = useParams();
  const company = useAppSelector(selectCompany);
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const driversHistoryListStatus = useAppSelector(
    selectDriversHistoryListStatus,
  );
  useEffect(() => {
    if (company && driversHistoryListStatus === "idle") {
      void dispatch(driversHistoryAsync(company.uuid));
    }
  }, [dispatch, company, driversHistoryListStatus]);

  const sidePanelAction = useCallback(
    (props: Partial<AdvancedAnalyticsVehicles>) => {
      navigate(`/home/fleet/advanced_analytics/${props.uuid}`);
    },
    [navigate],
  );

  if (params.tab !== "advanced_analytics") {
    return;
  }

  return (
    <SharedInterfaceAnalyticsVehiclesTab
      sidePanelAction={sidePanelAction}
      sidePanel={<AdvancedAnalyticsVehicleSidePanel />}
    />
  );
};
